import { formatters } from './pt-formatters'
import { labels } from './pt-labels'

export const t = {
  ...labels,
  ...formatters,
}
